import { MSelect, MSpinner } from "components/Shared";
import { MSelectOption } from "components/Shared/MSelect";
import { EmployeeListDto } from "interfaces/Mueller.Business.Models";
import React, { useEffect, useRef, useState } from "react";
import { getEmployeesByRoles } from "requests/employee";

interface AddAgentDialogContentProps {
  excludedEmployeeIds?: number[],
  employeeRoles: number[],
  onAgentSelectCallback: (newValue: MSelectOption) => void,
}

const AddAgentDialogContent = (props: AddAgentDialogContentProps) => {

  const [agents, setAgents] = useState<EmployeeListDto[]>([]);
  const [isFetchingAgents, setIsFetchingAgents] = useState<boolean>(true);

  const mounted = useRef<boolean>(true);

  useEffect(() => {
    getEmployeesByRoles(
      props.employeeRoles,
      (response: EmployeeListDto[]) => {
        if (props.excludedEmployeeIds)
          response = response.filter(a => !props.excludedEmployeeIds.includes(a.employeeId)); //Don't include agents in the list that already have a mapping
        setAgents(response);
        setIsFetchingAgents(false);
      },
      mounted
    );
  }, []);

  if (isFetchingAgents)
    return <MSpinner />;

  return(
    <MSelect 
      options={agents.map(agent => ({ label: agent.firstLastName, value: agent.employeeId}))}
      onChange={props.onAgentSelectCallback}
    />
  );
};

export default AddAgentDialogContent;